import { render, staticRenderFns } from "./WeiboLogin.vue?vue&type=template&id=66d91290&scoped=true&"
import script from "./WeiboLogin.vue?vue&type=script&lang=js&"
export * from "./WeiboLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d91290",
  null
  
)

export default component.exports